import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import Illustrations from "../desktop/Illustrations/Page-404.svg";

export default function ErrorPage() {
  const navigate = useNavigate();

  return (
    <ErrorrPageStyle>
      <main>
        <div className="error">
          <div className="error-text">
            <p className="error-404">404</p>
            <p className="error-p">Error</p>
          </div>
          <div className="message">
            <p>Oops! the page you are looking for does not exist anymore</p>
            <button onClick={() => navigate("/")} className="btn">
              go back
            </button>
          </div>
        </div>
        <div className="img-conatainer">
          <img src={Illustrations} alt="" />
        </div>
      </main>
    </ErrorrPageStyle>
  );
}
const ErrorrPageStyle = styled.div`
  background-color: ${({ theme }) => theme.colors.bgcolor};
  height: calc(100vh - 170px);
  main {
    display: flex;
    justify-content: space-evenly;
    .error {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      height: 70vh;
      @media (min-width: 800px) {
        /* margin-top: -55px; */
      }
      .error-text {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        position: relative;
        .error-404 {
          color: ${({ theme }) => theme.colors.error};
          font-size: 11rem;
          font-weight: 800;
        }
        .error-p {
          color: ${({ theme }) => theme.colors.error};
          font-size: 50px;
          font-weight: 800;
          position: absolute;
          top: 180px;
          left: 10px;
        }
      }
      .message {
        width: 330px;

        p {
          width: 200px;
          color: ${({ theme }) => theme.colors.error};
          font-size: 18px;
        }
        button {
          background-color: ${({ theme }) => theme.colors.colorgreen};
          margin-top: 20px;
          color: ${({ theme }) => theme.colors.primarycolor};
          font-size: 20px;
          padding: 10px 30px;
          border-radius: 5px;
          cursor: pointer;
        }
      }
    }
    .img-conatainer {
      width: 400px;
      height: 70vh;
      @media (max-width: 800px) {
        display: none;
      }
      img {
        width: inherit;
        height: inherit;
      }
    }
  }
`;
